import { render } from "./SettingsView.vue?vue&type=template&id=216e0403&scoped=true"
import script from "./SettingsView.vue?vue&type=script&lang=js"
export * from "./SettingsView.vue?vue&type=script&lang=js"

import "./SettingsView.vue?vue&type=style&index=0&id=216e0403&scoped=true&lang=css"

import exportComponent from "/home/PersonaExplorer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216e0403"]])

export default __exports__